import { commonColor } from '/@/utils/color'

// 任务类型
export enum TaskType {
  Immediate = 0, // 立即执行
  Timed = 1, // 单次定时任务
  Condition = 2, // 条件任务
}

// 审批类型
export enum TaskApproval {
  PENDING = 0, // 等待审批
  APPROVED = 1, // 已审批
  REJECTED = 2, // 已拒绝
  SUBMITTED_FOR_APPROVAL = 3, // 已提交审批
  NO_APPROVAL_REQUIRED = 4, // 无需审批
  APPROVAL_EXCEPTION = 5, // 审批异常
  SUBMITTED_FOR_AIRSPACE_APPROVAL = 6, // 已提交空域审批
}

// export const TaskTypeMap = {
//   [TaskType.Immediate]: 'Immediate',
//   [TaskType.Timed]: 'Timed',
// }

export const TaskApprovalStatus = {
  [TaskApproval.PENDING]: '等待审批',
  [TaskApproval.APPROVED]: '已审批',
  [TaskApproval.REJECTED]: '已拒绝',
  [TaskApproval.SUBMITTED_FOR_APPROVAL]: '已提交审批',
  [TaskApproval.NO_APPROVAL_REQUIRED]: '无需审批',
  [TaskApproval.APPROVAL_EXCEPTION]: '审批异常',
  [TaskApproval.SUBMITTED_FOR_AIRSPACE_APPROVAL]: '已提交空域审批'
}

export const TaskApprovalStatusColor = {
  [TaskApproval.PENDING]: commonColor.BLUE,
  [TaskApproval.APPROVED]: commonColor.NORMAL,
  [TaskApproval.REJECTED]: commonColor.FAIL,
  [TaskApproval.SUBMITTED_FOR_APPROVAL]: commonColor.BLUE,
  [TaskApproval.NO_APPROVAL_REQUIRED]: commonColor.NORMAL,
  [TaskApproval.APPROVAL_EXCEPTION]: commonColor.FAIL,
  [TaskApproval.SUBMITTED_FOR_AIRSPACE_APPROVAL]: commonColor.BLUE
}

export const TaskTypeMap = {
  [TaskType.Immediate]: '立即',
  [TaskType.Timed]: '定时',
  [TaskType.Condition]: '条件定时',
}

export const TaskTypeOptions = [
  { value: TaskType.Immediate, label: TaskTypeMap[TaskType.Immediate] },
  { value: TaskType.Timed, label: TaskTypeMap[TaskType.Timed] },
  { value: TaskType.Condition, label: TaskTypeMap[TaskType.Condition] },
]

// 失控动作
export enum OutOfControlAction {
  ReturnToHome = 0,
  Hover = 1,
  Land = 2,
}

export const OutOfControlActionMap = {
  [OutOfControlAction.ReturnToHome]: '返航',
  [OutOfControlAction.Hover]: '继续执行',
  [OutOfControlAction.Land]: '降落',
}

export const OutOfControlActionOptions = [
  { value: OutOfControlAction.ReturnToHome, label: OutOfControlActionMap[OutOfControlAction.ReturnToHome] },
  { value: OutOfControlAction.Hover, label: OutOfControlActionMap[OutOfControlAction.Hover] },
  // { value: OutOfControlAction.Land, label: OutOfControlActionMap[OutOfControlAction.Land] },
]

// 任务状态
export enum TaskStatus {
  Wait = 1, //  待执行
  Carrying = 2, // 执行中
  Success = 3, // 完成
  CanCel = 4, // 取消
  Fail = 5, // 失败
  Paused = 6, // 暂停
}

// export const TaskStatusMap = {
//   [TaskStatus.Wait]: 'To be performed',
//   [TaskStatus.Carrying]: 'In progress',
//   [TaskStatus.Success]: 'Task completed',
//   [TaskStatus.CanCel]: 'Task canceled',
//   [TaskStatus.Fail]: 'Task failed',
//   [TaskStatus.Paused]: 'Paused',

// }

export const TaskStatusMap = {
  [TaskStatus.Wait]: '待执行',
  [TaskStatus.Carrying]: '执行中',
  [TaskStatus.Success]: '完成',
  [TaskStatus.CanCel]: '取消',
  [TaskStatus.Fail]: '失败',
  [TaskStatus.Paused]: '暂停',

}

export const TaskStatusColor = {
  [TaskStatus.Wait]: commonColor.BLUE,
  [TaskStatus.Carrying]: commonColor.BLUE,
  [TaskStatus.Success]: commonColor.NORMAL,
  [TaskStatus.CanCel]: commonColor.FAIL,
  [TaskStatus.Fail]: commonColor.FAIL,
  [TaskStatus.Paused]: commonColor.BLUE,
}

// 任务执行 ws 消息状态
export enum TaskProgressStatus {
  Sent = 'sent', // 已下发
  inProgress = 'in_progress', // 执行中
  Paused = 'paused', // 暂停
  Rejected = 'rejected', // 拒绝
  Canceled = 'canceled', // 取消或终止
  Timeout = 'timeout', // 超时
  Failed = 'failed', // 失败
  OK = 'ok', // 上传成功
}

// 任务进度消息
export interface TaskProgressInfo {
  bid: string,
  output:{
    ext: {
      current_waypoint_index: number,
      media_count: number // 媒体文件
    },
    progress:{
      current_step: number,
      percent: number
    },
    status: TaskProgressStatus
  },
  sn: string,
  result: number,
}

// ws status => log status
export const TaskProgressWsStatusMap = {
  [TaskProgressStatus.Sent]: TaskStatus.Carrying,
  [TaskProgressStatus.inProgress]: TaskStatus.Carrying,
  [TaskProgressStatus.Rejected]: TaskStatus.Fail,
  [TaskProgressStatus.OK]: TaskStatus.Success,
  [TaskProgressStatus.Failed]: TaskStatus.Fail,
  [TaskProgressStatus.Canceled]: TaskStatus.CanCel,
  [TaskProgressStatus.Timeout]: TaskStatus.Fail,
  [TaskProgressStatus.Paused]: TaskStatus.Paused,
}

// 根据媒体文件上传进度信息，前端自己判断出的状态
export enum MediaStatus { // 媒体上传进度
  ToUpload = 1, // 待上传
  Uploading = 2, // 上传中
  Empty = 3, // 无媒体文件
  Success = 4, // 上传成功
}

export const MediaStatusMap = {
  [MediaStatus.ToUpload]: '待上传',
  [MediaStatus.Uploading]: '上传中',
  [MediaStatus.Success]: '上传成功',
  [MediaStatus.Empty]: '无媒体文件',
}

// export const MediaStatusMap = {
//   [MediaStatus.ToUpload]: 'Waiting to upload',
//   [MediaStatus.Uploading]: 'Uploading…',
//   [MediaStatus.Success]: 'Uploaded',
//   [MediaStatus.Empty]: 'No media files',
// }

export const MediaStatusColorMap = {
  [MediaStatus.ToUpload]: commonColor.BLUE,
  [MediaStatus.Uploading]: commonColor.BLUE,
  [MediaStatus.Success]: commonColor.NORMAL,
  [MediaStatus.Empty]: commonColor.WARN,
}

// 媒体上传进度消息
export interface MediaStatusProgressInfo {
  job_id: string,
  media_count: number
  uploaded_count: number,
}

// 媒体上传优先级消息
export interface TaskMediaHighestPriorityProgressInfo {
  pre_job_id: string,
  job_id: string,
}
